import type { SVGProps } from 'react';

export function BoneIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16.5 1a3.5 3.5 0 0 1 3.468 3.032A3.499 3.499 0 0 1 19.5 11c-.332 0-.646-.07-.878-.129-.275-.07-.421-.115-.61-.153a.9.9 0 0 0-.282-.026c-.007.002-.005-.002-.023.015l-7 7c-.018.018-.014.016-.015.023a.9.9 0 0 0 .026.282c.038.189.084.335.153.61.058.232.129.546.129.878a3.5 3.5 0 0 1-6.968.468A3.499 3.499 0 0 1 4.5 13c.332 0 .647.07.878.129.275.07.421.115.61.153.168.034.248.031.282.026.007-.002.005.002.023-.015l7-7c.018-.018.014-.016.015-.023a.9.9 0 0 0-.026-.282c-.038-.189-.084-.335-.153-.61A3.6 3.6 0 0 1 13 4.5 3.5 3.5 0 0 1 16.5 1" />
    </svg>
  );
}
